import '../css/module_skill.scss';

import Collapse from 'bootstrap/js/dist/collapse'
import Modal from 'bootstrap/js/dist/modal'
import Dropdown from 'bootstrap/js/dist/dropdown'

import Tab from 'bootstrap/js/dist/tab'

import {doLast} from './module_last';
import { initFirebaseApp } from './module_firebase';
import { manageLogin } from './module_auth_helper';
import {stopAllCard} from './module_player-card';

import {
    sentryAPIError, 
    alertNotification, 
    setSkillXpLevelBar,
    funnelUpdateWhenAvailable,
    attachTryPremiumSubscribe,
} from './module_common';

import {
    skillAddFavourite,
    skillRemoveFavourite,
} from './module_api_call';

import {attachToggleActionButton} from './module_toggle-button';

import {attachCtaActions} from './module_actions';

import {
    initCardLazyLoad,
    updateCardLazyLoad,
} from './module_lazyload';

import './module_common_actions';

import { openModal } from './module_modal';

import {configBookCard} from './module_book_card';

import { initNavbar } from './module_header';

function loadModuleBook(moduleId){
    const manageErr = function(err, msg){
        alertNotification(messages['genericApiError'])
        let data = {'error_text': msg}
        for (const [key, value] of formData) {
            data[key] = value
        }
        sentryAPIError(ep, err, data, 'loadModuleBook', true);
    }
    const ep = moduleBookEndPoint
    let formData = new FormData();
    formData.append('skill', SKILL_ID);
    formData.append('skill_slug', SKILL_SLUG);
    formData.append('module', moduleId);
    return fetch(ep, {
        method: 'POST',
        credentials: "include",
        body: formData
    }).then((response) => {
        if (!response.ok) {
            response.json()
                .then((data)=>{
                    const message = response.status+" "+response.statusText+", "+data.message
                    const err = new Error(message)
                    err.name = "Ajax Request Error"
                    manageErr(err, message)
                })
            return
        }
        return response.json()
    }).catch((err) => {
        const msg = err.name+": "+err.message
        manageErr(err, msg)
    })
}

function attachModuleClick(){
    $('.heading-box').click(function(){
        const target = $(this).data("target")
        const moduleId = $(target).data("moduleid")
        if ($.inArray(moduleId, filledModules) != -1) {
            $(target).collapse("toggle")
            return 
        }
        loadModuleBook(moduleId)
            .then((data) => {
                if (!data) return 
                const container = $('.bookcardcontainer'+moduleId)
                container.append(data.cards)
                filledModules.push(moduleId)
                const targetModule = data.targetModuleClass
                if (targetModule != ""){
                    const els = $('.'+targetModule)
                    attachModuleDetailOpenModal(els)
                    attachModalClose($(els[0]))
                }
                configBookCard()
                $(target).collapse("toggle")
            })
        }
    )
}

function manageSkillFavourite(skillId, action){
    if (action === 'remove'){
        return skillRemoveFavourite(skillId)
    }
    return skillAddFavourite(skillId)
}

function attachModuleDetailOnLoad(){
    const els = $('.moduleDetail')
    els.each(function(){
        attachModuleDetailOpenModal($(this))
    })
}

function attachModalCloseOnLoad(){
    const els = $('.moduleDetail')
    attachModalClose($(els[0]))
}

function attachModuleDetailOpenModal(el){
    const module = el.data("module")
    el.click(function(){
        stopAllCard()
        openModal("#" + SKILL_MODULE_MODAL_BASE + module, 'attachModuleDetailOpenModal')
        return false
    })
}

function attachModalClose(el) {
    const module = el.data("module")
    $("#" + SKILL_MODULE_MODAL_BASE + module).on('hidden.bs.modal', function (e) {
        stopAllCard()
    })
}

function toggleCollapsedClass(el){
    const moduleId = el.data("moduleid")
    const parent = $(".heading-box[data-target='#collapse"+moduleId+"']")
    parent.toggleClass("collapsed")
}

function attachModuleAccordionEvent(){
    // This event fires immediately when the show instance method is called.
    $(".cancollapse").on('show.bs.collapse', function(event){
        updateCardLazyLoad()
        toggleCollapsedClass($(event.target))
    })

    // This event is fired immediately when the hide method has been called.
    $(".cancollapse").on('hide.bs.collapse', function(event){
        toggleCollapsedClass($(event.target))
    })
}

function attachXpBoxClick(){
    $('.xp-box').click(function(){
        openModal('#' + SKILL_XP_MODAL, 'attachXpBoxClick')
    })
}

// need this to manage modal-in-modal backdrop layer
function manageBackdropLayerForMobilrActionInModal(){
    // relatedTarget defined by openModalWithRef (for modal open via JS)
    // manage Backdrop layer for Bootstrapm Modal https://getbootstrap.com/docs/5.3/components/modal/
    $(".modal").on("show.bs.modal", function(e){
        if (e.relatedTarget === undefined) return
        const el = $(e.relatedTarget)
        
        if (el.parents(".module-detail-modal").length == 1){
            // action click for a card in module modal
            // add class for backdrop layer relative to Module modal
            $(".modal-backdrop").addClass("old")
        }
    })

    $(".modal").on("shown.bs.modal", function(e){
        if (e.relatedTarget === undefined) return
        const el = $(e.relatedTarget)
        
        if (el.parents(".module-detail-modal").length == 1){
            // action click for a card in module modal
            // set backdrop layer z-index for action modal relative to card in modal
            // #mobile-card-actions-mod element has a z-index of 1070 (see module_skill.scss)
            $(".modal-backdrop:not(.old)").css("z-index", 1060)
            
        }
    })
}

$(function () {
    initFirebaseApp()
    manageLogin()

    attachTryPremiumSubscribe()
    
    doLast()
    initCardLazyLoad()

    initNavbar()
    configBookCard()

    manageBackdropLayerForMobilrActionInModal()

    attachToggleActionButton(manageSkillFavourite)
    attachModuleClick()
    
    attachModuleDetailOnLoad()
    attachModalCloseOnLoad()
    attachXpBoxClick()
    setSkillXpLevelBar()

    attachCtaActions()

    attachModuleAccordionEvent()

    if (!isPageReloadedAfterLogin) funnelUpdateWhenAvailable('skill_viewed')
});